export type NavigationFeatureKey = 'solutions' | 'industries' | 'resources' | 'company' | 'services';

export type NavigationFeatureSetting =
  | boolean
  | {
      enabled?: boolean;
      disableChildLinks?: boolean;
    };

type NavigationFeatures = Partial<Record<NavigationFeatureKey, NavigationFeatureSetting>>;

/**
 * Toggle navigation categories and child link interactivity without touching component code.
 * - Set `enabled: false` (or the value to false) to hide an entry entirely.
 * - Set `disableChildLinks: true` to render dropdown items as non-clickable.
 */
export const navigationFeatures: NavigationFeatures = {
  solutions: { enabled: true, disableChildLinks: true },
  industries: { enabled: true, disableChildLinks: true },
  resources: true,
  company: true,
  services: false,
};

const normalize = (setting?: NavigationFeatureSetting) => {
  if (typeof setting === 'boolean') {
    return { enabled: setting, disableChildLinks: false };
  }
  return {
    enabled: setting?.enabled !== false,
    disableChildLinks: setting?.disableChildLinks === true,
  };
};

export const isFeatureEnabled = (key: NavigationFeatureKey) => {
  const { enabled } = normalize(navigationFeatures[key]);
  return enabled;
};

export const areChildLinksDisabled = (key: NavigationFeatureKey) => {
  const { disableChildLinks } = normalize(navigationFeatures[key]);
  return disableChildLinks;
};

